var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
      ],
      staticClass: "buttons",
    },
    [
      _vm.isDisplaySaveButton
        ? _c("div", [
            _c(
              "div",
              { attrs: { title: _vm.$t("button.save") } },
              [
                _c(
                  "pui-button",
                  {
                    staticClass: "mb-2",
                    attrs: { disabled: _vm.isButtonDisabled },
                    on: {
                      click: function ($event) {
                        return _vm.saveEventChanges()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isDisplaySubmitButton
        ? _c("div", [
            _c(
              "div",
              { attrs: { title: _vm.$t("button.submit") } },
              [
                _c("pui-lightbox", {
                  ref: "submitModalRef",
                  staticClass: "modal",
                  attrs: {
                    "default-header-label": _vm.$t("info.submitModalTitle"),
                    "default-trigger-label": _vm.$t("info.submit"),
                    "fit-content": true,
                    fullscreen: false,
                    "show-lightbox-close-icon": true,
                    "close-on-overlay-click": false,
                  },
                  on: { "puilightbox:close": _vm.closeSubmitDialog },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("info.submitModalText")) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "lightbox-footer",
                        fn: function () {
                          return [
                            _c(
                              "pui-button",
                              {
                                attrs: { state: "secondary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmSubmit()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("yes")) + " ")]
                            ),
                            _c(
                              "pui-button",
                              {
                                attrs: { state: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.closeSubmitDialog()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3628700292
                  ),
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isDisplayFinalButton
        ? _c("div", [
            _c(
              "div",
              { attrs: { title: _vm.$t("button.final") } },
              [
                _c(
                  "pui-button",
                  {
                    staticClass: "mb-2",
                    attrs: { disabled: _vm.isButtonDisabled },
                    on: {
                      click: function ($event) {
                        return _vm.saveAndChangeStatus(755)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("info.final")) + " ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isDisplayReOpenButton
        ? _c("div", [
            _c(
              "div",
              { attrs: { title: _vm.$t("button.reOpen") } },
              [
                _c(
                  "pui-button",
                  {
                    staticClass: "mb-2",
                    attrs: { disabled: _vm.isButtonDisabled },
                    on: {
                      click: function ($event) {
                        return _vm.saveAndChangeStatus(754)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("info.reOpen")) + " ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isDisplayRequestInfoButton
        ? _c("div", [
            _c(
              "div",
              { attrs: { title: _vm.$t("button.request") } },
              [
                _c(
                  "pui-button",
                  {
                    staticClass: "mb-2",
                    attrs: { disabled: _vm.isButtonDisabled },
                    on: {
                      click: function ($event) {
                        return _vm.saveAndChangeStatus(754)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("info.requestFurtherInformation")) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }